import React from 'react';
import {
    FormControl,
    FormLabel,
    FormElement,
    FormHelperText,
    FormHeader,
    Input,
    InputGroup,
    InputSuffix,
    useFormState,
} from '@fiverr-private/forms';
import { Text } from '@fiverr-private/typography';
import { useIdentificationContext } from '@fiverr-private/identification_core';
import { appTranslate } from '../../../i18n';
import { getInputSuffixIcon } from '../../../shared/utils/getInputSuffixIcon';
import { FormSchema } from '../EmailIdentificationStep.constants';

interface Props {
    onChange: (value: string) => void;
    loading: boolean;
}

export const UsernameOrEmailInput = ({ onChange, loading }: Props) => {
    const { isValidating, errors } = useFormState<FormSchema>({ name: 'usernameOrEmail' });
    const { mode, variant } = useIdentificationContext();
    const isSignUpMode = mode === 'sign_up';

    const icon = getInputSuffixIcon({
        loading: loading || isValidating,
        error: Boolean(errors.usernameOrEmail),
    });

    return (
        <FormControl name="usernameOrEmail">
            <FormHeader>
                <FormLabel htmlFor="identification-usernameOrEmail">
                    <Text fontWeight="semibold">
                        {appTranslate(
                            isSignUpMode
                                ? 'fields.identification_login.label_when_sign_up'
                                : 'fields.identification_login.label_when_sign_in'
                        )}
                    </Text>
                </FormLabel>
            </FormHeader>

            <FormElement>
                <InputGroup onChange={(event) => onChange(event.target.value)}>
                    <Input
                        autoFocus
                        id="identification-usernameOrEmail"
                        placeholder={
                            isSignUpMode ? appTranslate<string>('fields.identification_login.placeholder') : undefined
                        }
                        autoComplete="email"
                    />
                    <InputSuffix>{icon}</InputSuffix>
                </InputGroup>
            </FormElement>
            <FormHelperText {...(variant === 'onboarding' ? { emptyLines: 1 } : {})} />
        </FormControl>
    );
};
